<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs nav-tabs-highlight mb-0 mr-0" id="startpage-editor-tabs">
          <li class="nav-item" style="border-left-width:0px !important">
            <a @click="activateNewsMode" href="#newspanel" style="border-left-width:0px;" class="nav-link active show" data-toggle="tab">
              <i class="icon-magazine"></i>
              {{$t('news')}}
            </a>
          </li>
          <li class="nav-item" style="border-left-width:0px !important">
            <a @click="activateDatesMode" href="#datespanel" style="border-left-width:0px;" class="nav-link" data-toggle="tab">
              <i class="icon-calendar"></i>
              {{$t('important_dates')}}
            </a>
          </li>
          <!--
          <li class="nav-item" style="border-left-width:0px !important;">
            <a @click="activateCoverMode" href="#coverpanel" style="border-left-width:0px;" class="nav-link" data-toggle="tab">
              <i class="icon-home5 "></i>
              {{$t('cover')}}
            </a>
          </li>-->
        </ul>
        <div class="container-fluid editor-container" v-bind:id="getId()" ref="container" style="">
          <div class="row" style="height: 100%">
            <div class="col p-2" style="padding-left:0px !important">
              <div class="tab-content border-top-0 rounded-top-0 mb-0" style="height: 100%">

                <div id="newspanel" class="tab-pane fade show active pl-1" style="height: 100%">
                  <news-editor @cancel="cancel" ref="newsEditor"></news-editor>
                </div>
                <div id="datespanel" class="tab-pane fade pl-1" style="height: 100%">
                  <importantdates-editor ref="datesEditor"></importantdates-editor>
                </div>
                <div id="coverpanel" class="tab-pane fade pl-1" style="height: 100%">
                  <cover-editor ref="coverEditor"></cover-editor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "startpage-editor-container",
    components: {
      
    },
    props: {
      
    },
    data() {
      return {

      };
    },
    methods: {
      reset() {
        this.$refs.newsEditor.cancel();
      },
      cancel(view) {
        this.$emit("cancel", view)
        this.$root.$emit("cancel-startpage-editor", view)
      },
      updateNews(id) {
        this.activateNewsMode();
        this.$refs.newsEditor.update(id);
      },
      copyNews(id) {
        this.activateNewsMode();
        this.$refs.newsEditor.copy(id);
      },
      updateDate() {
        this.activateDatesMode();
        this.$refs.datesEditor.loadDate(id);
      },
      activateTab(id) {
        this.activeTab = id;
        $('#startpage-editor-tabs a[href="#' + id + '"]').tab('show');
      },
      hideTab(id) {
        $('#startpage-editor-tabs a[href="#' + id + '"]').hide();
      },
      showTab(id) {
        $('#startpage-editor-tabs a[href="#' + id + '"]').show();
      },
      activateNewsMode() {
        this.activateTab("newspanel")
      },
      activateDatesMode() {
        this.activateTab("datespanel")
      },
      activateCoverMode() {
        this.activateTab("coverpanel")
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {

      }
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>

<style scoped>
  

</style>



// WEBPACK FOOTER //
// src/components/startpage/startpage-editor-container.vue